import React, { useState } from 'react'
import AdvertisementItem from './AdvertisementItem'

const AdvertisementsFireplace = ({items, features, className}) => {
    const [adIsClosed, closeAd] = useState(false)
    const imageURLs = {
        desktop: false,
        mobile: false,
        desktopScrolled: false,
        mobileScrolled: false
    }
    const itemOrigin = 'Fireplace'
    const scrolledClass = adIsClosed ? ' is-scrolled' : className
    
    return (
        <div id="fireplace" className={'custom-placements-fireplace' + scrolledClass}>
            <AdvertisementItem
                item={items[0]}
                imageURLs={imageURLs}
                itemOrigin={itemOrigin}
                imgTag={true}
            />
            {scrolledClass === '' && <div className='close-button-wrapper fireplace'><button className='close-button cursor-pointer' onClick={() => closeAd(true)}><span className='screen-reader-text'>CLOSE</span></button></div>}
        </div>
    )
}

export default AdvertisementsFireplace